// export const clientId  = "604220926946-1oqbrr18me54a3icgo5b4opu4c857pu5.apps.googleusercontent.com";
export const clientId  = "14756760360-ouruef0qu8mmj4pf5diamngmf72mhmbh.apps.googleusercontent.com";

export const linkedInClientId = "78ybgh06jnivad";


export const linkedInRedirectURL = "http://localhost:3000/login";

export const linkedInClientSecret = "PaU2T7EJiEIi1raZ";
